module.exports = __webpack_public_path__ + "static/media/Aveny soffa 3-sits med divan tex-bull brown 2897 detalj 2023 7.ffa82061.jpg";